/* Panier libre Semaine rose : tout le panier part en UN paiement chez le partenaire.

   Regle de prix, la meme que snippets/cart-summary.liquid :
   1. chaque ligne vaut son prix Semaine rose (_ks_palier, pose a l'ajout) ;
      un pack, un lot ou un trio vaut son montant de ligne ;
   2. on additionne ;
   3. on paie le plus haut montant encaissable (table __KS_LIENS__) qui reste
      sous cette somme. L'ecart est la reduction Octobre rose.
   Au-dela du dernier montant encaissable, on ne part pas : le tiroir le dit et
   son bouton est desactive.

   L'ecouteur est pose sur window en phase de capture : il passe AVANT les
   anciens intercepteurs (tunnel de campagne, ks-cart-boite.js), qui ne
   savaient lire qu'une seule ligne. */
(function () {
  'use strict';
  if (window.__ksPanierLibre__) return;
  window.__ksPanierLibre__ = true;

  var SORTIES = [
    '[name="checkout"]',
    '.cart__checkout-button',
    'a[href^="/checkout"]',
    'a[href*="/cart/checkout"]'
  ].join(',');
  var FBCLID_JOURS = 7;
  /* Livraison offerte des 20 EUR de soins ; en dessous, 3 EUR s'ajoutent AVANT l'arrondi
     au montant de paiement (1,95 + 3 = 4,95). Meme regle que snippets/cart-summary.liquid. */
  var KS_SEUIL = 2000, KS_PORT = 300;
  /* Le panier se remplit jusqu'a 170 EUR (brut). Au-dela du dernier montant encaissable,
     on paie ce montant et l'ecart grossit la reduction. Meme regle que snippets/cart-summary.liquid. */
  var KS_PLAFOND = 17000;
  var KS_CADEAUX = 'Analyse de peau offerte (boutiques Paris) + Ticket d’or inclus';

  function paliers() {
    return Object.keys(window.__KS_LIENS__ || {})
      .map(Number).filter(function (n) { return n > 0; })
      .sort(function (a, b) { return a - b; });
  }

  function estLot(it) {
    var p = it.properties || {};
    return !!p._ks_skus || it.handle === 'ma-boite-de-soins';
  }

  /* Valeur Semaine rose d'une ligne, en centimes. Null si la ligne n'est pas une offre. */
  function valeur(it) {
    var p = it.properties || {};
    var c = parseInt(p._ks_palier, 10) || 0;
    /* Boite, lot, trio : le prix de la variante porteuse, meme regle que snippets/cart-summary.liquid. */
    if (c > 0 && estLot(it)) return it.original_price * it.quantity;
    if (c > 0 && c < it.original_price) return c * it.quantity;
    return null;
  }

  /* Valeurs de ligne comptees par snippets/cart-summary.liquid (data-ks-valeurs). Le tiroir lit le prix
     Semaine rose sur la fiche quand une ligne n'a pas de _ks_palier : le paiement doit compter le meme. */
  function affiche() {
    var s = document.querySelectorAll('script[data-ks-valeurs]');
    for (var i = s.length - 1; i >= 0; i--) { try { return JSON.parse(s[i].textContent) || {}; } catch (e) {} }
    return {};
  }

  function calcule(panier, frais) {
    var items = (panier && panier.items) || [];
    var total = 0, offres = 0;
    var aff = frais || affiche();
    items.forEach(function (it) {
      var v = valeur(it), a = aff[it.key];
      if (a && a[0] > 0) {
        var l = a[0] === it.quantity ? a[1] : Math.round(a[1] / a[0] * it.quantity);
        if (v != null || l !== it.final_line_price) v = l;
      }
      if (v != null) offres++;
      total += (v != null ? v : it.final_line_price);
    });
    var port = (offres && total > 0 && total < KS_SEUIL) ? KS_PORT : 0, brut = total + port;
    var m = paliers(), paye = 0, maxi = m.length ? m[m.length - 1] : 0;
    m.forEach(function (x) { if (x <= brut) paye = x; });
    return { items: items, offres: offres, total: total, port: port, brut: brut, paye: paye, maxi: maxi, plafond: Math.max(maxi, KS_PLAFOND), trop: brut > Math.max(maxi, KS_PLAFOND) };
  }

  function propre(t) {
    return String(t || '').replace(/&/g, 'et').replace(/[#?]/g, '').replace(/\s+/g, ' ').trim();
  }

  function image(u) {
    if (!u) return '';
    u = String(u).split('?')[0].split('#')[0];
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.indexOf('http') !== 0) return 'https://' + location.host + u;
    return u;
  }

  /* Ce que le partenaire affiche (titre, image, noms) et ce qui sert au colis (references). */
  function contenu(items) {
    var noms = [], refs = [], nb = 0, distincts = {};
    items.forEach(function (it) {
      var p = it.properties || {};
      if (estLot(it)) {
        var lst = String(p._ks_skus || it.handle).split(',').filter(function (x) { return x.trim(); });
        var n = String(p.Contenu || it.product_title).split(' + ');
        var q = parseInt(p._ks_qte, 10) || 1;
        if (q > 1 && lst.length === q) {
          refs.push(lst[0].trim() + ' x' + q);
          noms.push(propre(n[0]) + ' x' + q);
        } else {
          refs.push(lst.join(','));
          noms.push(n.map(propre).join(' + '));
        }
        lst.forEach(function (r) { distincts[r.trim()] = 1; });
        nb += lst.length * it.quantity;
      } else {
        refs.push(it.handle + (it.quantity > 1 ? ' x' + it.quantity : ''));
        noms.push(propre(it.product_title) + (it.quantity > 1 ? ' x' + it.quantity : ''));
        distincts[it.handle] = 1;
        nb += it.quantity;
      }
    });
    var seul = items.length === 1 ? items[0] : null;
    var titre, img;
    if (seul && !estLot(seul) && seul.quantity === 1) {
      titre = propre(seul.product_title);
      img = seul.image;
    } else if (seul && estLot(seul)) {
      titre = 'Pack Semaine rose, ' + nb + ' soin' + (nb > 1 ? 's' : '');
      img = seul.handle === 'ma-boite-de-soins' ? window.__KS_IMG_BOITE__
          : (Object.keys(distincts).length === 1 ? seul.image : window.__KS_IMG_COFFRET__);
    } else {
      titre = 'Panier Semaine rose, ' + nb + ' soin' + (nb > 1 ? 's' : '');
      img = Object.keys(distincts).length === 1 ? items[0].image : (window.__KS_IMG_COFFRET__ || items[0].image);
    }
    return { titre: titre, image: image(img || window.__KS_IMG_LOGO__), noms: noms.join(' + '), refs: refs.join(','), nb: nb };
  }

  /* fbclid et fbc : memes sources et meme format que le tunnel de campagne. */
  function fbclid() {
    try {
      var d = new URLSearchParams(location.search).get('fbclid');
      if (d) return { v: d, t: Date.now() };
    } catch (e) {}
    try {
      var o = JSON.parse(localStorage.getItem('ef_fbclid') || 'null');
      if (o && o.v && (Date.now() - o.t) < FBCLID_JOURS * 864e5) return o;
    } catch (e) {}
    var m = document.cookie.match(/_fbc=fb\.\d+\.(\d+)\.([^;]+)/);
    return m ? { v: m[2], t: Number(m[1]) } : null;
  }
  function fbc(o) {
    var c = document.cookie.match(/_fbc=([^;]+)/);
    if (c) return decodeURIComponent(c[1]);
    var n = Math.max(1, location.hostname.split('.').length - 1);
    return o ? 'fb.' + n + '.' + o.t + '.' + o.v : null;
  }

  function lien(r) {
    var c = contenu(r.items);
    if (r.port) c.noms += ' + Livraison ' + (r.port / 100).toFixed(2).replace('.', ',') + ' €';
    /* Dernier palier : les cadeaux (analyse de peau, ticket d'or) s'affichent aussi au paiement. */
    if (r.paye && r.paye === r.maxi) {
      c.noms = KS_CADEAUX + ' + ' + c.noms;
      c.titre += ' + analyse de peau et ticket d’or offerts';
    }
    var u = typeof window.__KS_BOITE_URL__ === 'function'
      ? window.__KS_BOITE_URL__(r.paye, c.refs, c.nb, c.image, c.noms, c.titre)
      : null;
    if (!u) return null;
    var f = fbclid();
    if (f) u += '&fbclid=' + encodeURIComponent(f.v) + '&sub9=' + encodeURIComponent(fbc(f));
    return u;
  }

  function avis(titre, texte) {
    var vieux = document.querySelector('.ks-blocage');
    if (vieux) vieux.parentNode.removeChild(vieux);
    var b = document.createElement('div');
    b.className = 'ks-blocage';
    b.setAttribute('role', 'alert');
    b.innerHTML = '<b>' + titre + '</b>' + texte + '<button type="button" aria-label="Fermer">×</button>';
    document.body.appendChild(b);
    var ferme = function () { if (b.parentNode) b.parentNode.removeChild(b); };
    b.querySelector('button').addEventListener('click', ferme);
    setTimeout(ferme, 9000);
  }

  /* Commander : on part sur la page de passage /cart?view=kspaye (templates/cart.kspaye.liquid).
     Le serveur y rend le panier et la valeur de chaque ligne a l'instant du clic, ce script calcule
     le montant et remplace la page par le lien de paiement. Une simple navigation : marche sur
     mobile, PC, Safari, Chrome, Firefox et les navigateurs integres (TikTok, Instagram). */
  var PASSAGE = '/cart?view=kspaye';
  var enRoute = false, bouton = null;
  /* Bouton en attente jusqu'au depart ; rendu tel quel au retour arriere. */
  function attente(el) {
    if (!el || el.__ksHtml__ != null) return;
    bouton = el;
    el.__ksHtml__ = el.innerHTML;
    el.setAttribute('aria-busy', 'true');
    el.style.pointerEvents = 'none';
    el.style.opacity = '.75';
    el.textContent = 'Chargement…';
  }
  function rends() {
    var el = bouton;
    bouton = null;
    if (!el || el.__ksHtml__ == null) return;
    el.innerHTML = el.__ksHtml__;
    el.__ksHtml__ = null;
    el.removeAttribute('aria-busy');
    el.style.pointerEvents = '';
    el.style.opacity = '';
  }
  function commande(el) {
    if (enRoute) return Promise.resolve(false);
    enRoute = true;
    attente(el);
    window.location.href = PASSAGE;
    return Promise.resolve(true);
  }
  /* Sur la page de passage : panier et valeurs rendus par le serveur, depart sans retour possible. */
  function passe() {
    var repli = function () { var x = document.getElementById('ks-repli'); if (x) x.hidden = false; };
    setTimeout(repli, 6000);
    try {
      var r = calcule(JSON.parse(document.getElementById('ks-panier').textContent));
      if (!r.items.length) return location.replace('/cart');
      /* Aucune offre dans le panier : c'est un panier boutique, le checkout Shopify reprend. */
      if (!r.offres) return location.replace('/checkout');
      if (r.trop) return location.replace('/cart?ks_trop=1');
      var u = r.paye ? lien(r) : null;
      if (!u) return repli();
      if (r.items.some(function (it) { return it.handle === 'ma-boite-de-soins'; })) {
        try { localStorage.removeItem('ks_boite_v1'); } catch (e) {}
      }
      location.replace(u);
    } catch (e) { repli(); }
  }
  window.__KS_COMMANDE__ = commande;
  window.__KS_CALCUL__ = calcule;

  if (window.__KS_PASSAGE__) { passe(); return; }

  function sortie(el) { return el && el.closest ? el.closest(SORTIES) : null; }
  window.addEventListener('click', function (e) {
    var el = sortie(e.target);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    commande(el);
  }, true);
  /* Formulaire envoye sans clic (touche Entree, bouton du clavier mobile) vers le checkout. */
  window.addEventListener('submit', function (e) {
    var el = sortie(e.submitter);
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    commande(el);
  }, true);
  window.addEventListener('pageshow', function (e) { if (e.persisted) { enRoute = false; rends(); } });
  /* Retour de la page de passage quand le panier depasse le plafond. */
  try {
    if (/[?&]ks_trop=1/.test(location.search)) {
      var trop = function () {
        avis('Ton panier dépasse ' + (KS_PLAFOND / 100).toFixed(2).replace('.', ',') + ' €',
             'C’est le maximum d’un panier Semaine rose. Retire un soin pour valider ta commande.');
      };
      if (document.body) trop(); else document.addEventListener('DOMContentLoaded', trop);
    }
  } catch (e) {}
})();
